// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function EsgSustainabilityFromJSON(json) {
    return {
        'clarityEstimates': !exists(json, 'clarityEstimates') ? undefined : json['clarityEstimates'],
        'gpReportedDataFromYearBefore': !exists(json, 'gpReportedDataFromYearBefore') ? undefined : json['gpReportedDataFromYearBefore'],
    };
}
export function EsgSustainabilityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'clarityEstimates': value.clarityEstimates,
        'gpReportedDataFromYearBefore': value.gpReportedDataFromYearBefore,
    };
}
